<template>
    <div
        v-show="!!showPriceTrend" class="price-Trend"
        @click.stop="inShowPriceTrend"
    >
        <div class="priceTrend-type">
            <div
                v-for="(item, index) of priceTrendData.sku_ver_list"
                :key="index"
                :class="currentType === index ? 'active' : 'priceTrend-type-item'"
                @click.stop="changeType(index)"
            >
                {{ item.sku_ver_name }}
            </div>
        </div>
        <div class="price-Trend-container">
            <div
                id="main1"
            ></div>
            <div class="bottom">
                <div class="bottom-left">
                    数据来自Steamdb
                </div>
                <div class="bottom-right">
                    <span class="title">{{ `${skuVerName}今日价格:` }}</span>
                    <span class="rmb">&nbsp;¥</span>
                    <span class="price">{{ skuValue }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pricetrend1 from 'public/assets/imgs/pricetrend1.png';
import Pricetrend2 from 'public/assets/imgs/pricetrend2.png';
import Pricetrend3 from 'public/assets/imgs/pricetrend3.png';
import Pricetrend4 from 'public/assets/imgs/pricetrend4.png';
import Pricetrend5 from 'public/assets/imgs/pricetrend5.png';
import Pricetrend6 from 'public/assets/imgs/pricetrend6.png';
import {getUrlParams} from '@/utils/url';
import api from '@/api';

export default {
    props: {
        showPriceTrend: {
            type: Boolean,
            default: false,
        },
        isLately: {
            type: Number,
            default: 1,
        },
        isAll: {
            type: String,
            default: 'latest30d',
        },
    },
    data() {
        return {
            options: {
                animation: false,
                legend: {
                    data: [
                        {
                            name: '百度游戏',
                            icon: ('image://' + Pricetrend6 + ''),
                        },
                        {
                            name: 'Steam',
                            icon: ('image://' + Pricetrend5 + ''),
                        },
                    ],
                    x: 'left',
                    padding: [10, 0, 8, 0],
                    itemHeight: 26, // 修改icon图形大小
                    itemWidth: 26, // 修改icon图形大小
                    textStyle: {
                        fontSize: '14px',
                        fontFamily: 'PingFangSC-Regular',
                        itemHeight: '42px',
                        color: '#666666',
                        fontWeight: 400,
                        backgroundColor: 'rgba(0, 0, 0, 0)', // 透明的背景颜色
                    },
                    selectedMode: false,
                },
                grid: {
                    left: '1%',
                    right: '6%',
                    bottom: '1%',
                    containLabel: true,
                    tooltip: {
                        trigger: 'axis',
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [],
                    maxInterval: 0,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#CCCCCC',
                        },
                    },
                    axisLabel: {
                        show: true,
                        interval: 0, // 横轴信息全部显示
                        margin: 10, // 刻度标签与轴线之间的距离
                        textStyle: {
                            color: '#CCCCCC',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: { // y轴分隔线样式设置
                            color: '#DCDFE5 ', // 颜色
                            type: 'dashed', // 虚线
                        },
                    },
                    axisLabel: {
                        interval: 0, // 横轴信息全部显示
                        margin: 15, // 刻度标签与轴线之间的距离
                        textStyle: {
                            color: '#CCCCCC',
                        },
                    },
                },
                series: [
                    {
                        name: 'Steam',
                        type: 'line',
                        symbol: ('image://' + Pricetrend4 + ''),
                        symbolSize: 12,
                        smooth: true,
                        lineStyle: {
                            color: '#DCDFE5', // 折线颜色
                            width: 3,
                        },
                        data: [],
                    },
                    {
                        name: '百度游戏',
                        type: 'line',
                        symbol: ('image://' + Pricetrend3 + ''),
                        symbolSize: 30,
                        smooth: true,
                        lineStyle: {
                            color: '#3388FF', // 折线颜色
                            width: 3,
                        },
                        data: [],
                    },
                ],
            },
            pricetrend1: Pricetrend1,
            pricetrend2: Pricetrend2,
            currentType: 0,
            PriceTime: [],
            newPriceTime: [],
            SteamPriceValue: [],
            BaiduPriceValue: [],
            priceTrendData: {},
            skuVerName: '',
            skuValue: '',
            skuVerValue: '',
            priceTrendText: '',

        };
    },
    async created() {
        await this.getPriceTrendInfo();
        this.givepriceTrendData();
        this.initOptions();
        this.initSkuInfo();
    },
    mounted() {
        this.inShowPriceTrend();
        this.initChart();
    },
    watch: {
        options: {
            handler() {
                let myChart = this.$echarts.init(document.querySelector('#main1'));
                myChart.setOption(this.options);
            },
            deep: true,
        },
        isAll: {
            async handler() {
                await this.getPriceTrendInfo();
                this.PriceTime = [],
                this.newPriceTime = [],
                this.SteamPriceValue = [],
                this.BaiduPriceValue = [],
                this.initOptions();
            },
        },
        skuVerName: {
            async handler() {
                await this.getPriceTrendInfo();
                this.PriceTime = [],
                this.newPriceTime = [],
                this.SteamPriceValue = [],
                this.BaiduPriceValue = [],
                this.initOptions();
                this.skuValue = this.priceTrendData.price_list[0].curr_price;
            },
        },
        priceTrendData: {
            async handler() {
                this.priceTrendText = this.priceTrendData.price_list[0].price_trend_text;
                this.givepriceTrendData();
            },
        },
    },
    methods: {
        async getPriceTrendInfo() {
            const {appId} = getUrlParams();
            await api.zone.getPriceTrend({
                data: {
                    time_tag: this.isAll,
                    app_id: appId,
                    sku_ver: '' || String(this.skuVerValue),
                },
            }).then(res => {
                this.priceTrendData = res.data;
            });
        },
        initChart() {
            let myChart = this.$echarts.init(document.querySelector('#main1'));
            myChart.setOption(this.options, true);
        },
        initOptions() {
            const BaiduPlatPrice = this.priceTrendData.price_list[0].plat_price;
            const SteamPlatPrice = this.priceTrendData.price_list[1].plat_price;
            SteamPlatPrice.forEach(item => {
                if (item.price_date) {
                    this.PriceTime.push(item.price_date);
                }
            });
            SteamPlatPrice.forEach(item => {
                if (item.price_value) {
                    this.SteamPriceValue.push(item.price_value);
                }
            });
            BaiduPlatPrice.forEach(item => {
                if (item.price_date) {
                    this.PriceTime.push(item.price_date);
                }
            });
            this.newPriceTime = this.PriceTime;
            this.newPriceTime.pop();
            this.options.xAxis.data = this.newPriceTime;
            BaiduPlatPrice.forEach(item => {
                if (this.priceTrendData.price_list[0].plat_price.length !== 1) {
                    this.BaiduPriceValue.push(item.price_value);
                }
                else {
                    while (this.BaiduPriceValue.length < this.newPriceTime.length - 1) {
                        this.BaiduPriceValue.push(null);
                    }
                    this.BaiduPriceValue.push({
                        value: item.price_value,
                        symbol: ('image://' + Pricetrend1 + ''),
                        symbolSize: 25,
                        label: {
                            show: true,
                            formatter: this.priceTrendData.price_list[1].price_trend_text,
                            position: 'left',
                            color: '#ffffff',
                            borderColor: '#FFFFFF',
                            fontSize: 12,
                            padding: 3,
                            distance: 1,
                            borderRadius: 2,
                            borderWidth: 1,
                            backgroundColor: '#FF462B',
                        },
                    });
                }
            });
            if (this.priceTrendData.price_list[0].price_trend_text === '') {
                this.BaiduPriceValue[this.BaiduPriceValue.length - 1].label.show = false;
            }
            this.options.series[1].data = this.BaiduPriceValue;
            this.options.series[0].data = this.SteamPriceValue;
            this.options.series[0].data[this.options.series[0].data.length - 1] = {
                name: 'Steam',
                value: this.SteamPriceValue[this.SteamPriceValue.length - 1],
                type: 'line',
                symbol: ('image://' + Pricetrend2 + ''),
                symbolSize: 25,
                smooth: true,
            },
            this.TypeName = this.priceTrendData.sku_ver_list[0].sku_ver_name;
        },
        changeType(index) {
            if (index === this.currentType) {
                this.currentType = index;
            }
            else {
                this.currentType = index;
            }
            this.skuVerName = this.priceTrendData.sku_ver_list[index].sku_ver_name;
            this.skuVerValue = this.priceTrendData.sku_ver_list[index].sku_ver_value;
        },
        givepriceTrendData() {
            const skuVerList = this.priceTrendData.sku_ver_list;
            this.$emit('givepriceTrendData', this.priceTrendData, skuVerList, this.priceTrendText);
        },
        initSkuInfo() {
            if (this.priceTrendData.sku_ver_list.length > 0) {
                this.skuVerName = this.priceTrendData.sku_ver_list[0].sku_ver_name;
                this.skuValue = this.BaiduPriceValue[this.BaiduPriceValue.length - 1].value;
                this.skuVerValue = this.priceTrendData.sku_ver_list[0].sku_ver_value;
            }
        },
        inShowPriceTrend() {},
    },
};
</script>

<style scoped lang="scss">
@import "~@/common/style/mixin/utils";
@import "~@/common/style/mixin/mixins";
.price-Trend {
    position: relative;
    overflow: hidden;
    .priceTrend-type {
        display: flex;
        align-items: center;
        margin-top: 27px;
        height: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow-x: scroll;
        overflow-y: hidden;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
        .priceTrend-type-item {
            box-sizing: border-box;
            padding: 15px 15px;
            height: 72px;
            background: #F7F7F7;
            border-radius: 9px;
            font-family: PingFangSC-Medium;
            font-size: 36px;
            color: #888888;
            text-align: center;
            line-height:42px;
            margin-right: 24px;
            font-weight: 500;
        }
        .active {
            height: 72px;
            box-sizing: border-box;
            padding: 15px 15px;
            background: #3388FF;
            font-family: PingFangSC-Medium;
            border-radius: 9px;
            color: #fff;
            text-align: center;
            line-height:46px;
            margin-right: 24px;
            font-weight: 500;
        }
    }
    .price-Trend-container {
        #main1 {
            width: 1155px;
            height: 760px;
        }
        .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 54px;
            height: 57px;
            .bottom-left {
                width: 342px;
                height: 42px;
                font-family: PingFangSC-Regular;
                font-size: 42px;
                color: #DFDFDF;
                text-align: right;
                line-height: 42px;
                font-weight: 400;
                margin-top: 13px;
            }
            .bottom-right {
                .title {
                    width: 336px;
                    height: 42px;
                    font-family: PingFangSC-Regular;
                    font-size: 42px;
                    color: #1F1F1F;
                    letter-spacing: 0;
                    line-height: 42px;
                    font-weight: 400;
                }
                .rmb {
                    width: 26px;
                    height: 42px;
                    font-family: PingFangSC-Medium;
                    font-size: 42px;
                    color: #FF462B;
                    letter-spacing: 0;
                    line-height: 42px;
                    font-weight: 500;
                }
                .price {
                    width: 92px;
                    height: 57px;
                    font-family: PingFangSC-Medium;
                    font-size: 57px;
                    color: #FF462B;
                    letter-spacing: 0;
                    line-height: 57px;
                    font-weight: 500;
                }
            }
        }
    }
}
</style>